import React from "react";
import { Link } from "react-router-dom";

const SideNavigation = props => {
    return (
        <div className="side-nav">
            <div className="side-nav__item">
                <Link className={"side-nav__link " + (props.selected == "titles" ? "side-nav__link--selected" : "")} to="/PM/titles"><i className="fas fa-gamepad icon side-nav__icon"></i> Titles</Link>
                <Link className={"side-nav__link " + (props.selected == "projects" ? "side-nav__link--selected" : "")} to="/PM/projects"><i className="fas fa-tasks icon side-nav__icon"></i> Project Orders</Link>
                <Link className={"side-nav__link " + (props.selected == "analyses" ? "side-nav__link--selected" : "")} to="/PM/analyses"><i className="fas fa-chart-pie icon side-nav__icon"></i> Analyses</Link>
                <Link className={"side-nav__link " + (props.selected == "glossaries" ? "side-nav__link--selected" : "")} to="/PM/glossaries"><i className="fas fa-language icon side-nav__icon"></i> Glossaries</Link>
                <Link className={"side-nav__link " + (props.selected == "memories" ? "side-nav__link--selected" : "")} to="/PM/memories"><i className="fas fa-brain icon side-nav__icon"></i> Memories</Link>
                <Link className={"side-nav__link " + (props.selected == "users" ? "side-nav__link--selected" : "")} to="/PM/users"><i className="fas fa-users icon side-nav__icon"></i> Users</Link>
            </div>
        </div>
    )
}

export default SideNavigation;